import type { ResponsiveDialogTitleProps } from '@/shared/components/ui/custom/responsive-dialog';
import { ResponsiveDialogTitle } from '@/shared/components/ui/custom/responsive-dialog';
import { cn } from '@/shared/utils/cn';

export function DownloadModalTitle(props: ResponsiveDialogTitleProps) {
  const { className, ...rest } = props;
  return (
    <ResponsiveDialogTitle
      className={cn('text-card-foreground text-2xl', className)}
      {...rest}
    />
  );
}
